import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, filter, switchMap, take, tap } from 'rxjs/operators';
import { AppState } from '../models/app-state.models';
import { DocPopupTypes } from '../models/dialog.models';
import { PopupService } from '../services/popup.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    private window;

    constructor(
        private store: Store<AppState>,
        private popupService: PopupService,
        private router: Router
    ) {
        this.window = getWindow();
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError(error => {

                // if (error instanceof HttpErrorResponse && error.status === 403) {
                // } else {
                if (!req.url.includes('login') && !req.url.includes('refresh') && !req.url.includes('logout')) {
                    console.log(error);
                    // ! Handle this in a better way
                    // * Skip error message during onboarding page
                    if(error.url.includes('/v1/doctors/')) return 
                    this.showError(error.error);
                }

                if (req.url.includes('login') && req.method === 'POST') {
                    this.showError(error.error);
                }
                // }
                return throwError(error);
            })
        );
    }

    private showError(error) {
        if (!error) {
            return;
        }
        if(this.router.url.includes('/u/')) return;
        console.log(error);
        if(error.msg){
            this.popupService.openDialog({
                type: DocPopupTypes.error,
                message: error.msg,
                heading:'Error',
                buttonText:'Ok',
            });
        }
     
    }

}

function getWindow(): any {
    return window;
}